import { Outlet } from "react-router-dom";
import type { RoleConfig } from "@/data/panels";
import RoleSidebar from "./RoleSidebar";
import RoleTopbar from "./RoleTopbar";
import RoleBottomNav from "./RoleBottomNav";
import { AiCoachProvider } from "@/components/feature/ai-coach/AiCoachProvider";
import AiCoach from "@/components/feature/ai-coach/AiCoach";

export default function RolePanelShell({
  roleLabel,
  homePath,
  homeLabel,
  menu,
  bottomNav,
  privateRole,
}: RoleConfig) {
  return (
    <AiCoachProvider>
      <div className="dx-panel-theme min-h-screen bg-background-100">
        <RoleSidebar
          menu={menu}
          homePath={homePath}
          roleLabel={roleLabel}
        />
        <div className="lg:pl-[260px]">
          <RoleTopbar
            menu={menu}
            homePath={homePath}
            homeLabel={homeLabel}
            roleLabel={roleLabel}
            privateRole={privateRole}
          />
          <main className="p-4 md:p-6 lg:p-8 pb-safe-nav">
            <Outlet />
          </main>
        </div>
        <RoleBottomNav
          menu={menu}
          bottomNav={bottomNav}
          homePath={homePath}
          roleLabel={roleLabel}
        />
      </div>
      <AiCoach />
    </AiCoachProvider>
  );
}